var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5C10.395 3.5 7.56 6.23875 7.16363 9.73438C6.40119 9.85723 5.68615 10.1839 5.09421 10.6799C4.50226 11.1759 4.05543 11.8227 3.801 12.5519C1.6485 13.1722 0 15.092 0 17.5C0 20.4085 2.3415 22.75 5.25 22.75H22.75C25.6585 22.75 28 20.4085 28 17.5C28 15.96 27.2519 14.581 26.1677 13.6168C25.9648 10.542 23.5121 8.0885 20.426 7.92925C19.3725 5.36638 16.9557 3.5 14 3.5ZM14 5.25C16.4167 5.25 18.3487 6.79875 19.0312 8.995L19.2237 9.625H20.125C22.5356 9.625 24.5 11.5894 24.5 14V14.4375L24.8552 14.7114C25.284 15.04 25.6324 15.4618 25.874 15.9449C26.1157 16.4281 26.2442 16.9598 26.25 17.5C26.25 19.4915 24.7415 21 22.75 21H5.25C3.2585 21 1.75 19.4915 1.75 17.5C1.75 15.7325 3.01875 14.3605 4.62 14.0822L5.19487 13.9729L5.30425 13.3971C5.56675 12.2185 6.6115 11.375 7.875 11.375H8.75V10.5C8.75 7.55125 11.0513 5.25 14 5.25ZM14 10.1447L13.37 10.7459L9.87 14.2459L11.13 15.5059L13.125 13.5074V19.25H14.875V13.5074L16.87 15.5041L18.13 14.2441L14.63 10.7441L14 10.1447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/upload_photo.59487b0951b10b9050b4c71f0d9a79a7.svg";
export { ForwardRef as ReactComponent };